import React from "react";
import { AlertTriangle, X } from "lucide-react";

interface GroupIdMappingModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onProceed: () => void;
}

export const GroupIdMappingModal = ({ open, onOpenChange, onProceed }: GroupIdMappingModalProps) => {
  const handleProceed = () => {
    onProceed();
    onOpenChange(false);
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900">Mapping Status Check</h3>
          <button
            onClick={() => onOpenChange(false)}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        
        <div className="p-6">
          <div className="border border-yellow-200 bg-yellow-50 rounded-lg p-4">
            <div className="flex items-start space-x-2">
              <AlertTriangle className="h-4 w-4 text-yellow-600 mt-0.5 flex-shrink-0" />
              <div className="space-y-2 flex-1">
                <p className="font-medium text-yellow-800">Group Id Mapping missing.</p>
                <p className="text-sm text-yellow-700">
                  Do you still want to proceed? We will alert you about missing groups and customer 
                  IDs. You can ingest missing data here.
                </p>
                <div className="flex gap-2 mt-3">
                  <button 
                    className="px-3 py-1 text-sm bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
                    onClick={handleProceed}
                  >
                    Proceed Anyway
                  </button>
                  <button 
                    className="px-3 py-1 text-sm text-yellow-700 hover:bg-yellow-100 rounded-md transition-colors"
                    onClick={() => onOpenChange(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};